import React from "react";
import {useTranslation} from "react-i18next";

import Typography from "@mui/material/Typography";

import ShowMoreMenu from "../../../../../../../common/showMoreMenu";
import SettingsTable from "../table";
import { Add as AddIcon } from '@vedmarket/ui-kit';
import {COLORS} from "../../../../../../../../config/constants";
import Button from "@mui/material/Button";
import { Check as CheckIcon } from '@vedmarket/ui-kit';

type Props = {
  onClose(): void;
  goToNewTemplate(): void;
}

const ModalSettingsList = ({onClose, goToNewTemplate} : Props) => {

  const { t } = useTranslation()

  const [ selected, setSelected ] = React.useState('');

  const headCells = [
    {
      id: 'name',
      numeric: false,
      disablePadding: false,
      label: t('common__text__name'),
    },
    {
      id: 'createDate',
      numeric: false,
      disablePadding: false,
      label: t('common__text__dateOfCreation'),
    },
    {
      id: 'editDate',
      numeric: false,
      disablePadding: false,
      label: t('common__text__modifiedDate'),
    },
    {
      id: 'settings',
      numeric: false,
      disablePadding: false,
      label: '',
    },
  ];

  const preferences = [
    {
      id: 'name',
      width: 698,
    },
    {
      id: 'createDate',
      width: 144,
    },
    {
      id: 'editDate',
      width: 152,
    },
    {
      id: 'settings',
      width: 32,
    },
  ];

  const getShowMoreMenu = () => <div className='routes-table__showMore'>
    <ShowMoreMenu menuItems={[
      {
        title: t('actions__text__edit'),
        onClick: () => console.log('edit'),
      },
      {
        title: t('actions__text__delete'),
        onClick: () => console.log('remove')
      },
    ]}/>
  </div>;

  const results = [
    {
      id: 1,
      name: 'Отчет 1. Поставка канцелярских товаров',
      createDate: '03.05.2025 12:45:12',
      editDate: '03.05.2025 12:45:12',
      settings: getShowMoreMenu()
    },
    {
      id: 2,
      name: 'Отчет 2. Садовая мебель (для менеджеров)',
      createDate: '08.05.2025 12:45:12',
      editDate: '08.05.2025 12:45:12',
      settings: getShowMoreMenu()
    },
    {
      id: 3,
      name: 'Отчет 3. Садовая мебель (для директора)',
      createDate: '14.05.2025 12:45:12',
      editDate: '14.05.2025 12:45:12',
      settings: getShowMoreMenu()
    },
  ]

  const handleCreateTemplate = () => goToNewTemplate();

  return <>
    <div className='modal_settings__list'>
      <Typography variant='h6' sx={{ marginBottom: '28px' }}>
        {t('calc__text__summary__reportTemplates')}
      </Typography>
      <div className='modal_settings__table'>
        <SettingsTable
          rows={results}
          count={3}
          headCells={headCells}
          preferences={preferences}
          primaryField='id'
          checkboxesWidth='48px'
          chooseItem={(id) => setSelected(id)}
        />
      </div>
      <button className='modal_settings__add-button' onClick={handleCreateTemplate}>
        <AddIcon style={{marginRight: '8px', color: COLORS.BLUE}}/>
        <Typography variant='body1' sx={{color: COLORS.BLUE}}>
          {t('calc__text__summary__reportAReportTemplate')}
        </Typography>
      </button>
    </div>
    <div className='modal_settings__buttons'>
      <Button
        variant='outlined'
        sx={{ minWidth: '238px', marginRight: 3}}
        onClick={onClose}
      >{t('actions__text__cancel')}</Button>
      {selected && <Button
        variant='contained'
        onClick={goToNewTemplate}
        sx={{ width: '474px' }}
        startIcon={<CheckIcon/>}
      >{t('calc__text__summary__createAReport')}</Button>}
    </div>
  </>

}

export default ModalSettingsList
